import { ValidateAddressRequest } from 'src/app/core/models/operations/operations-pickup.model';

export const PICKUP_ADDRESS_CONSTANTS = {
  HEADER: $localize`Current Pickup Address`,
  CUSTOMER_NAME: $localize`Customer Name`,
  CONTACT_NAME: $localize`Contact Name`,
  CONTACT: $localize`Contact #`,
  STREET_ADDRESS: $localize`Street Address`,
  PREFIX: $localize`Prefix`,
  STREET_NAME: $localize`Street Name`,
  SUFFIX: $localize`Suffix`,
  STREET_TYPE: $localize`Street Type`,
  SUITE: $localize`Suite`,
  SUITE_FLOOR: $localize`Suite/Floor#`,
  FLOOR: $localize`Floor`,
  CITY_TOWN: $localize`City/Town`,
  PROVINCE: $localize`Province`,
  POSTAL_CODE: $localize`Postal Code`,
  PICKUP_LOCATION: $localize`Pickup Location`,
  NUMBER_OF_PACKAGES: $localize`Number of Pkgs`,
  LATITUDE: $localize`Latitude`,
  LONGITUDE: $localize`Longitude`,
  SLIC: $localize`SLIC`,
  VALIDATE: $localize`Validate`,
  ORIGINAL_ADDRESS: $localize`Original Address`,
  PARSED_ADDRESS: $localize`Parsed AAA Address`,
  CANADIAN_POSTAL_ERROR: $localize`! Invalid Postal Code`,
};

export const MOCK_VALIDATE_ADDRESS_REQUEST: ValidateAddressRequest = {
  addressValidation: {
    orderNumber: '29DAF3R14JH',
    userId: 'WEB_MNN0SDZ',
    address: {
      consignee: 'IVA CANADA ACR 12',
      city: 'CHARLOTTETOWN',
      state: 'PE',
      postalCode: 'C1E2A1',
      country: 'CA',
      floor: '',
      suite: '',
      streetParsed: {
        number: '345',
        name: 'MOUNT EDWARD',
        prefix: '',
        suffix: '',
        type: '',
      },
    },
  },
};

export enum ADDRESS_TYPE {
  ORIGINAL = 'original',
  PARSED = 'parsed',
}
